"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userSelectNone = exports.appearanceNone = void 0;
var _styledComponents = require("styled-components");
const appearanceNone = (0, _styledComponents.css)`
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  appearance: none;
`;
exports.appearanceNone = appearanceNone;
const userSelectNone = (0, _styledComponents.css)`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;
exports.userSelectNone = userSelectNone;